import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { GetAffiliateEarningsRequest } from "@/api/affiliates/types";
import { AffiliateApi } from "@/api/affiliates";

export const useAffiliateEarnings = ({
  affiliateId,
  ...params
}: GetAffiliateEarningsRequest) => {
  const { data, isError, isPending } = useQuery({
    queryKey: [QueryKey.AFFILIATE_EARNINGS, affiliateId, params],
    queryFn: () =>
      AffiliateApi.getAffiliateEarnings({ affiliateId, ...params }),
    enabled: !!affiliateId,
  });

  return {
    affiliateEarnings: data || [],
    affiliateEarningsError: isError,
    isAffiliateEarningsLoading: isPending,
  };
};
